import React, {useState, useRef, useLayoutEffect} from 'react';
import styles from './styles';
import IncrementForms from '../IncrementForms';
import formSchema from './formSchema';
import parentStyles from '../styles';
import config from '../../../../config/axios.config';
import axios from 'axios';
import {UserContext} from "../../../../Context/UserContext";
import {IconTextButton} from '@xpertdox_js/xdcomponents';
import {InstanceContext} from "../../../../InstanceContext";
import {btn_c_xdHighlight} from '@xpertdox_js/xdstyle';
import { trackError } from '../../../../utils/activityTracker';
import ContactDisplay from "./ContactDisplay";

const StudyContactsDropdown = props => {
  const [addToggle, setAddToggle] = useState(false);
  const [specialtyForms, setSpecialtyForms] = useState({});
  const { user, userAction } = React.useContext(UserContext);
  const {contextInstance} = React.useContext(InstanceContext);

  const editable = {}
  let ctms = {}
  if (props.data && props.data.specialty === 'Oncology') {
    editable.specialtyContacts = props.data.oncologyContacts ? props.data.oncologyContacts.filter(c => !c.ctms) : []
    ctms.specialtyContacts = props.data.oncologyContacts ? props.data.oncologyContacts.filter(c => c.ctms) : false
  } else if (props.data && props.data.specialty === 'Cardiology') {
    editable.specialtyContacts = props.data.cardiologyContacts ? props.data.cardiologyContacts.filter(c => !c.ctms) : []
    ctms.specialtyContacts = props.data.cardiologyContacts ? props.data.cardiologyContacts.filter(c => c.ctms) : false
  }

  const handleSave = () => {
    const url = `${config.apiUrl}/rt/console/saveSpecialtyContacts/${user.email}`;
    let newContacts = Object.values(specialtyForms).map(contact => {
      let value = {};
      contact.forEach(obj => {
        value[obj.id] = obj.value;
      })
      return value;
    });
    if(ctms.specialtyContacts) newContacts = [...newContacts, ...ctms.specialtyContacts]
    const body = {
      id: props.data._id,
      instance: contextInstance || user.instance,
      type: props.data.specialty
    }
    if (props.data.specialty === 'Oncology') body.oncologyContacts = newContacts
    if (props.data.specialty === 'Cardiology') body.cardiologyContacts = newContacts
    axios.post(url, body).then(() => {
      props.dataRefresh('specialtyContacts')
    }).catch(err => {
      console.log(err, "ERR")
      trackError({ error: err, history: props.history })
      if (err && err.response && err.response.status === 403) {
        userAction({type: 'logout'})
      }
    })
  }
  const elemRef = useRef();

  React.useEffect(() => {
    let newContacts = Object.values(specialtyForms).map(contact => {
      let value = {};
      contact.forEach(obj => {
        value[obj.id] = obj.value;
      })
      return value;
    });
    // console.log(newContacts, editable, "FPR<S")
    //GIVE OPTION TO SAVE AFTER EDITING
    if((
        JSON.stringify(newContacts) !== JSON.stringify(editable.specialtyContacts
        )) && !addToggle
    ) {
      setAddToggle(true)
    }
  }, [specialtyForms])

  // layout tracker
  useLayoutEffect(() => {
    if (elemRef.current) {
      props.measureCallback(elemRef.current)
    }
  }, [specialtyForms])

  return(
      <div style={{...parentStyles.container, position: 'relative', overflowX: 'auto'}} ref={elemRef}>
        {/* <h2 style={styles.title}>Oncology Contacts</h2> */}
        {ctms.specialtyContacts.map((data, i) => <ContactDisplay
            key={i}
            index={i}
            type='specialty'
            data={data}
            instance={contextInstance || user.instance}
            email={user.email}
            // protocol={props.data.protocolId}
            id={props.data._id}
        />)}
        <IncrementForms
          key='specialty'
          values={editable.specialtyContacts}
          addToggle={() => setAddToggle(!addToggle)}
          toggle={addToggle}
          forms={specialtyForms}
          setForms={setSpecialtyForms}
          formSchema={formSchema}
        />
        {addToggle && <div style={styles.saveBtnContainer}>
          <IconTextButton
            size='md'
            icon='save'
            preBuiltStyles={btn_c_xdHighlight}
            onClick={handleSave}
            text='Save Changes'
          />
        </div>}
      </div>
  )
}

export default StudyContactsDropdown;
